import styles from "./templates-loader.module.scss";
import React from "react";
import { LOADER_IMG } from "@whatslly/commons/constants";
import { AsyncImage } from "@whatslly/ui-components/AsyncImage";

export const TemplatesLoader = () => {
  return (
    <div className={styles.loader}>
      <AsyncImage alt="tuvis loader" src={LOADER_IMG} />
    </div>
  );
};
